import repoUrls from 'src/sections/repository/urls';

import {
  ARTIFACTS_PAGE_LENGTH,
  PAGE_QUERY_PARAM,
  PAGELEN_QUERY_PARAM,
  SORT_QUERY_PARAM,
} from '../../constants';
import { MavenVersionsResponse } from '../../types';
import { buildPackagesApiQueryString } from '../../utils';
import { packagesResourceFactory } from '../utils';

export const packagesMavenVersionsResource =
  packagesResourceFactory<MavenVersionsResponse>()({
    key: 'packages-maven-versions',
    pathParamNames: ['packageName', 'mavenBaseVersion'] as const,
    queryParamNames: [SORT_QUERY_PARAM, PAGE_QUERY_PARAM] as const,
    getRequestUrl: (context, pathParams, queryParams) => {
      const queryString = buildPackagesApiQueryString({
        ...queryParams,
        packageName: pathParams.packageName,
        baseVersion: pathParams.mavenBaseVersion,
        [PAGELEN_QUERY_PARAM]: ARTIFACTS_PAGE_LENGTH.toString(),
      });

      switch (context.container) {
        case 'repository':
          return repoUrls.api.internal.mavenVersions(
            context.workspaceSlug,
            context.repositorySlug,
            queryString
          );
        default:
          throw new Error('Invalid route context');
      }
    },
  });
